import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import IconChat from "../../components/icons/IconChat";
import { getParticipantInitials, getParticipantName } from "../../utils/participantDisplay";

export default function ConversationParticipants({ conversationId, isOpen }) {
    const [progresses, setProgresses] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isOpen || progresses !== undefined) return;
        axios
            .get("/api/conversationprogress?conversation=" + conversationId, { withCredentials: true })
            .then((response) => setProgresses(response.data))
            .catch((err) => console.error(err));
    }, [isOpen, conversationId, progresses]);

    if (!isOpen) return null;

    const finishedCount = Array.isArray(progresses) ? progresses.filter((p) => p.isFinished === 1).length : 0;

    return (
        <div className="conv-participants-panel" onClick={(e) => e.stopPropagation()}>
            <p className="conv-participants-summary">
                {progresses === undefined ? "Завантаження..." : `Проходили: ${progresses.length}, завершили: ${finishedCount}`}
            </p>

            {Array.isArray(progresses) && progresses.length === 0 ? <p className="conv-participants-empty">Ще ніхто не проходив цю розмову</p> : ""}

            <ul className="conv-participants-list">
                {(progresses || []).map((progress) => {
                    const name = getParticipantName(progress);
                    return (
                        <li key={progress.id} className="conv-participant-row" onClick={() => navigate("/messages/byconvprogress/" + progress.id)}>
                            <span className="conv-participant-avatar">{getParticipantInitials(name)}</span>
                            <span className="conv-participant-name">{name}</span>
                            <span className="conv-participant-date">
                                {progress.dAdd ? DateTime.fromISO(progress.dAdd, { setZone: true }).toFormat("dd.MM.yyyy") : ""}
                            </span>
                            <span className={`conv-participant-status ${progress.isFinished === 1 ? "done" : "pending"}`}>
                                {progress.isFinished === 1 ? "Завершено" : "В процесі"}
                            </span>
                            <IconChat fillColor="icon-teel" style={{ width: 18, height: 18 }} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
